import * as domainSettingService from '@/service/domainSetting'
import { checkBookingEngineSubdomainHost } from '@/composition/use-booking-engine'

const getIsFunBookV2DomainCustomization = host => {
  const config = useRuntimeConfig()
  const url = `https://${host}`

  const isMichelinDomain = host === config.public.MICHELIN_DOMAIN
  const isLocalEnv = config.public.CONFIG_ENV === 'local'
  const lineSubdomainUrl = `https://line.myfunnow.com${isLocalEnv ? ':8082' : ''}`
  const isBookingEngineSubdomainHost = checkBookingEngineSubdomainHost(host)

  if (url === config.public.BASE_URL || isMichelinDomain || url === lineSubdomainUrl || isBookingEngineSubdomainHost) {
    return false
  }

  return true
}

const switchBranchAndRedirect = async (axios, branchId, locale) => {
  const config = useRuntimeConfig()
  const { data: domainInfo } = await domainSettingService
    .verifyDomainCustomization(axios, { branchId })
    .catch(err => console.log('verifyDomainCustomization errors, error is: ', err))

  let to = ''
  if (domainInfo.funbook_ver === 1) {
    to = `${config.public.BASE_URL}/${locale}/branches/${domainInfo.branch_id}/funbook`
  } else if (domainInfo.domain) {
    const isLocalEnv = config.public.CONFIG_ENV === 'local'
    to = `${domainInfo.domain}${isLocalEnv ? ':8082' : ''}/${locale}/funbook/${domainInfo.branch_id}/branch`
  } else {
    to = `${config.public.BASE_URL}/${locale}/funbook/${domainInfo.branch_id}/branch`
  }

  location.href = to
}

export { getIsFunBookV2DomainCustomization, switchBranchAndRedirect }
